import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch { setUser(null); }
    finally { setLoading(false); }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    await refresh();
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    await refresh();
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* best-effort server logout; local state cleared regardless */ }
    setUser(null);
  };

  const hasPerm = (p) => {
    if (!user) return false;
    if (user.role === "super_admin") return true;
    return (user.effective_permissions || user.permissions || []).includes(p);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh, hasPerm }}>
      {children}
    </AuthCtx.Provider>
  );
}
